import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
    providedIn: 'root'
})
export class SanitizerService {

    constructor(
        @Inject(DOCUMENT) private _doc: any,
        private _domSanitizer: DomSanitizer,
    ) { }

    isNotHtml(value: string | null): boolean {
        if (value === null) {
            return true;
        }
        const safeValue = this._domSanitizer.sanitize(SecurityContext.HTML, value);
        const isHtml = this.unescapeHtml(safeValue || "") !== this.unescapeHtml(value || "");

        return !isHtml; // Return true if the input is safe
    }

    unescapeHtml(value: string): string {
        let wrapper = this._doc.createElement("textarea")
        wrapper.innerHTML = value;
        return wrapper.value;
    }
}
